import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

import moment from 'moment';

import { removeAttrInMetaTags } from 'utils/dom.mapper';
import { getVersion } from 'utils/version';

const version = getVersion();

const VersionTags = () => {
  const name = version.tag ? 'tag' : 'branch';

  useEffect(() => {
    removeAttrInMetaTags('data-react-helmet');
  }, []);

  return (
    <Helmet>
      <meta name={`rt-version-${name}`} content={version.tag || version.branch} />
      <meta name="rt-version-sha" content={version.sha} />
      <meta name="rt-version-time" content={moment(version.date).format('llll')} />
    </Helmet>
  );
};

export default VersionTags;
